export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11010.19e4d094.jpg";